export default __webpack_public_path__ + "static/media/I0007.1097f5b6.png";